<main class="container bg-white h-100 w-100 d-grid-center">
  <header class="mx-auto text-center">
    <h1 class="font-weight-light">We are sorry, the page you requested cannot be found.</h1>
    <p>The URL may be misspelled or the page you're looking for is no longer available.</p>
    <div class="py-4"></div>
    <a class="text-link" routerLink="/modeling-predictions">Return to home screen</a>
  </header>
</main>
